//export const API = 'https://short-linker-gordonmaloney.vercel.app/'
//export const API = 'https://python-shortlinkr.onrender.com/'

export const API = 'https://tenantshout-backend.vercel.app/api/campaigns'

export const OPTIN_API = 'https://long-ruby-narwhal-sock.cyclic.app/api/optins'
